export default __webpack_public_path__ + "static/media/gallery_08.c59c2553.jpg";